import { doGet, doPatch, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  BillingBalance,
  BillingConfig,
  BillingConsumption,
  BillingGranularity,
  BillingInvoices,
  BillingLedger,
  BillingProjects,
} from './types';

const BILLING_CONFIG = 'accounts/:accountId/billing/config';
const BILLING_BALANCE = 'accounts/:accountId/billing/balance';
const BILLING_CONSUMPTION = 'accounts/:accountId/billing/consumption';
const BILLING_INVOICES = 'accounts/:accountId/billing/invoices';
const BILLING_PROJECTS = 'accounts/:accountId/billing/projects';
const BILLING_LEDGER = 'accounts/:accountId/billing/ledger';

export const getBillingConfig = (accountId: string) =>
  doGet<BillingConfig>(
    generateNextPath(BILLING_CONFIG, { accountId }),
    LOGGER_TYPE.JUPITER,
    { prefix: 'nebula' },
  );

export const enrolAccount = (accountId: string) =>
  doPost<BillingConfig>(
    generateNextPath(BILLING_CONFIG, { accountId }),
    LOGGER_TYPE.JUPITER,
    {},
    { prefix: 'nebula' },
  );

export const patchBillingConfig = (
  accountId: string,
  body: { show_dashboard: boolean },
) =>
  doPatch<BillingConfig>(
    generateNextPath(BILLING_CONFIG, { accountId }),
    LOGGER_TYPE.JUPITER,
    body,
    { prefix: 'nebula' },
  );

export const getBillingBalance = (accountId: string) =>
  doGet<BillingBalance>(
    generateNextPath(BILLING_BALANCE, { accountId }),
    LOGGER_TYPE.JUPITER,
    { prefix: 'nebula' },
  );

export const getBillingConsumption = (
  accountId: string,
  granularity: BillingGranularity,
) =>
  doGet<BillingConsumption>(
    generateNextPath(BILLING_CONSUMPTION, { accountId }),
    LOGGER_TYPE.JUPITER,
    { prefix: 'nebula', params: { granularity } },
  );

export const getBillingInvoices = (
  accountId: string,
  startingOn?: string,
  endingBefore?: string,
) =>
  doGet<BillingInvoices>(
    generateNextPath(BILLING_INVOICES, { accountId }),
    LOGGER_TYPE.JUPITER,
    {
      prefix: 'nebula',
      params: {
        ...(startingOn ? { starting_on: startingOn } : {}),
        ...(endingBefore ? { ending_before: endingBefore } : {}),
      },
    },
  );

export const getBillingProjects = (accountId: string) =>
  doGet<BillingProjects>(
    generateNextPath(BILLING_PROJECTS, { accountId }),
    LOGGER_TYPE.JUPITER,
    { prefix: 'nebula' },
  );

export const getBillingLedger = (accountId: string) =>
  doGet<BillingLedger>(
    generateNextPath(BILLING_LEDGER, { accountId }),
    LOGGER_TYPE.JUPITER,
    { prefix: 'nebula' },
  );
